import axios from 'axios';
// const token =localStorage.getItem('werkenDeIn_user_token')
export const createApplyJob = async (data) => {
    try {
        const res = await axios.post(global.BASEURL + '/applyJob/create', data, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': global.TOKEN,
                'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
export const applyContract = async (data) => {
    try {
        const res = await axios.post(global.BASEURL + '/applyJob/contract/create/' + data.params, data, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': global.TOKEN,
                'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
export const applyJobHistory = async (lastId) => {
    try {
        const res = await axios.get(global.BASEURL + '/applyJob/job/history/' + lastId, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': global.TOKEN,
                'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
export const checkContract = async (data) => {
    try {
        const res = await axios.get(global.BASEURL + '/applyJob/check/contract/' + data.params, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': global.TOKEN,
                'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
export const getApplyJob = async (data) => {
    try {
        const res = await axios.post(global.BASEURL + `/applyJob/get/apply`,
            data, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': global.TOKEN,
                'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
export const getApplyJobById = async (params) => {
    try {
        const res = await axios.put(global.BASEURL + `/applyJob/getById/${params}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': global.TOKEN,
                'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

            }
        });
        return res;
    } catch (error) {
        throw error;
    }
};
export const updateStatus = async (data) => {
    try {
        const res = await axios.post(global.BASEURL + `/applyJob/update/status/${data.params}`,
            data
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': global.TOKEN,
                    'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

                }
            });
        return res;
    } catch (error) {
        throw error;
    }
};
export const emailTemplate = async (data) => {
    try {
        const res = await axios.put(global.BASEURL + `/applyJob/email/template/${data.params}`,
            data
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': global.TOKEN,
                    'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

                }
            });
        return res;
    } catch (error) {
        throw error;
    }
};
export const updateCertForm = async ({ params, data, token }) => {
    try {
        const res = await axios.post(global.BASEURL + `/applyJob/update/certform/${params}`,
            data
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': token,
                    'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

                }
            });
        return res;
    } catch (error) {
        throw error;
    }
};
export const checkCertForm = async ({ params, token }) => {
    try {
        const res = await axios.get(global.BASEURL + `/applyJob/check/certform/${params}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': token,
                    'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

                }
            });
        return res;
    } catch (error) {
        throw error;
    }
};
export const getByIdApplyJob = async (id, token) => {
    try {
        const res = await axios.put(global.BASEURL + `/applyJob/getById/${id}`,
            {}
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': token,
                    'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

                }
            });
        return res;
    } catch (error) {
        throw error;
    }
};
// export const getJobTemplate = async (params) => {
//     try {
//         const res = await axios.put(global.BASEURL + '/jobTemplate/getByCatId/' + params, {
//         }, {
//             headers: {
//                 'Content-Type': 'application/json',
//                 'x-auth-token': global.TOKEN,
// 'Accept-Language': JSON.parse(window.localStorage.getItem('werkendeIn_language')) || "dut"

//             }
//         });
//         return res;
//     } catch (error) {
//         console.log(error, "error");
//         throw error;
//     }
// };